import { UsuarioComisionFreelanceHistoricoService } from './../../../../_services/usuario-comision-freelance-historico.service';
import { UsuarioComisionFreelanceHistorico } from './../../../../_models/usuario-comision-freelance-historico';
import { UsuarioComisionFreelance } from './../../../../_models/usuario-comision-freelance';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UsuarioComisionFreelanceTarifa } from '../../../../_models/usuario-comision-freelance-tarifa';
import { UsuarioComisionFreelanceTarifaService } from '../../../../_services/usuario-comision-freelance-tarifa.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfirmationService } from 'primeng/api';
import { NavService } from '../../../../_services/_nav.service';
import { Subscription } from 'rxjs';
import { CanalComunicacion } from '../../../../_enums/enum';
import { ComunicationComponentsService } from '../../../../_services/comunication-components.service';
import { roundCustom } from '../../../../utils/utilidades';

@Component({
  selector: 'app-comision-freelance-tarifa',
  templateUrl: './comision-freelance-tarifa.component.html',
  styleUrls: ['./comision-freelance-tarifa.component.css']
})
export class ComisionFreelanceTarifaComponent implements OnInit, OnDestroy {

  @Input() comisionFreelance: UsuarioComisionFreelance;
  listado: UsuarioComisionFreelanceTarifa[] = [];
  lisUsuarioComisionFreelanceHistorico: UsuarioComisionFreelanceHistorico[] = [];
  columnas: any[] = [];
  formulario: FormGroup;
  submitted = false;
  cargando = true;
  regSeleccionado: any;
  subscription: Subscription;

  constructor( private navService: NavService,
               private fb: FormBuilder,
               private usuarioComisionFreelanceTarifaService: UsuarioComisionFreelanceTarifaService,
               private communicationService: ComunicationComponentsService,
               private conService: ConfirmationService,
               private usuariosComisionesFreelanceHistoricosService: UsuarioComisionFreelanceHistoricoService ) {
  }

  async ngOnInit() {
    this.columnas = [
      { field: 'rangoInferior', header: this.navService.buscarMensaje( 'USUARIOCOMISIONFREELANCETARIFA.LBL_RANGOINFERIOR' ), sort: false },
      { field: 'rangoSuperior', header: this.navService.buscarMensaje( 'USUARIOCOMISIONFREELANCETARIFA.LBL_RANGOSUPERIOR' ), sort: false },
      { field: 'porcentajeAplicado', header: this.navService.buscarMensaje( 'USUARIOCOMISIONFREELANCETARIFA.LBL_PORCENTAJEAPLICADO' ), sort: false },
      { field: 'porcentajeTarifa', header: this.navService.buscarMensaje( 'USUARIOCOMISIONFREELANCETARIFA.LBL_PORCENTAJETARIFA' ), sort: false },
      { field: 'det', header: this.navService.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];
    await this.cargarListado();
    this.cargarFormulario();
    this.conectarCanal();
    this.cargando = false;
  }

  conectarCanal() {
    this.subscription = this.communicationService.emisorComponent$.subscribe( async mensaje => {
      if ( mensaje.canal === CanalComunicacion.ACTUALIZARTARIFAS && mensaje.mensaje ) {
        this.cargando = true;
        await this.cargarListado();
        if ( this.formulario ) {
          this.calcularTarifa();
        }
        this.cargando = false;
      }
    } );
  }

  async cargarListado() {
    this.listado = await this.usuarioComisionFreelanceTarifaService.listadoPorUsuarioFreelance( this.comisionFreelance.idUsuarioComisionFreelance ).toPromise();
    this.ordenar();
  }

  ordenar(){
    this.listado = this.listado.sort(function (a, b) {
      if (Number(a.rangoInferior) > Number(b.rangoInferior)) {
        return 1;
      }
      if (Number(a.rangoInferior) < Number(b.rangoInferior)) {
        return -1;
      }
      return 0;
    });
  }

  cargarFormulario() {
    this.formulario = this.fb.group( {
      idUsuarioComisionFreelanceTarifa: [this.regSeleccionado ? this.regSeleccionado.idUsuarioComisionFreelanceTarifa : null , this.regSeleccionado ? [Validators.required] : []],
      idUsuarioComisionFreelance: [this.regSeleccionado ? this.regSeleccionado.idUsuarioComisionFreelance : this.comisionFreelance.idUsuarioComisionFreelance , [Validators.required]],
      rangoInferior: [ this.regSeleccionado ? this.regSeleccionado.rangoInferior : null, [ Validators.required ] ],
      rangoSuperior: [ this.regSeleccionado ? this.regSeleccionado.rangoSuperior : null, [ Validators.required ] ],
      porcentajeAplicado: [ this.regSeleccionado ? this.regSeleccionado.porcentajeAplicado : null, [ Validators.required ] ],
      porcentajeTarifa: [ this.regSeleccionado ? this.regSeleccionado.porcentajeTarifa : null, [ Validators.required ] ],
      indicadorHabilitado: [this.regSeleccionado ? this.regSeleccionado.indicadorHabilitado : true, [Validators.required] ]
    } );
  }

  onSubmit() {
    this.submitted = true;
    if ( !this.formulario.valid ) {
      return;
    }

    const valRango = this.validarRango();
    if ( valRango ) {
      this.navService.setMesage( 0, {
        severity: 'info', summary: this.navService.buscarMensaje( 'LBL_INFORMACION' ),
        detail: valRango
      } );
      return;
    }

    this.cargando = true;
    const registro = this.formulario.value;
    if ( registro.idUsuarioComisionFreelanceTarifa ) {
      this.usuarioComisionFreelanceTarifaService.actualizar(registro).subscribe(r => {
        this.validarModificicaciones(this.regSeleccionado);
        const itemIndex = this.listado.findIndex( x => x.idUsuarioComisionFreelanceTarifa === registro.idUsuarioComisionFreelanceTarifa );
        if ( itemIndex >= 0 ) {
          this.listado[ itemIndex ] = registro;
        }
        this.ordenar();
        this.finalizarGuardado( registro, 2 );
      });
    } else {
      this.usuarioComisionFreelanceTarifaService.crear(registro).subscribe(r => {
        this.validarModificicaciones();
        registro.idUsuarioComisionFreelanceTarifa = r.idUsuarioComisionFreelanceTarifa;
        this.listado.push( registro );
        this.ordenar();
        this.finalizarGuardado( registro, 1 );
      });
    }
  }


  finalizarGuardado( registro: any, tipo: number ) {
    this.reiniciarForm();
    this.navService.setMesage( tipo );
    this.cargando = false;
  }

  editar( registro: UsuarioComisionFreelanceTarifa ) {
    this.regSeleccionado = registro;
    this.reiniciarForm( false );
  }

  validarModificicaciones(usuarioComisionFreelanceTarifa: UsuarioComisionFreelanceTarifa = null) {
    let usuarioComisionFreelanceHistorico = {} as UsuarioComisionFreelanceHistorico;
    usuarioComisionFreelanceHistorico.idUsuarioComisionFreelance = this.comisionFreelance.idUsuarioComisionFreelance;
    if (!usuarioComisionFreelanceTarifa) {
      usuarioComisionFreelanceHistorico.datoNuevo = this.navService.buscarMensaje('USUARIOCOMISIONFREELANCETARIFA.LBL_RANGOINFERIOR') + ': ' + this.f.rangoInferior.value;
      this.lisUsuarioComisionFreelanceHistorico.push(Object.assign({}, usuarioComisionFreelanceHistorico));
      usuarioComisionFreelanceHistorico.datoNuevo = this.navService.buscarMensaje('USUARIOCOMISIONFREELANCETARIFA.LBL_RANGOSUPERIOR') + ': ' + this.f.rangoSuperior.value;
      this.lisUsuarioComisionFreelanceHistorico.push(Object.assign({}, usuarioComisionFreelanceHistorico));
      usuarioComisionFreelanceHistorico.datoNuevo = this.navService.buscarMensaje('USUARIOCOMISIONFREELANCETARIFA.LBL_PORCENTAJEAPLICADO') + ': ' + this.f.porcentajeAplicado.value;
      this.lisUsuarioComisionFreelanceHistorico.push(Object.assign({}, usuarioComisionFreelanceHistorico));
      usuarioComisionFreelanceHistorico.datoNuevo = this.navService.buscarMensaje('USUARIOCOMISIONFREELANCETARIFA.LBL_PORCENTAJETARIFA') + ': ' + this.f.porcentajeTarifa.value;
      this.lisUsuarioComisionFreelanceHistorico.push(Object.assign({}, usuarioComisionFreelanceHistorico));
      this.guardarUsuariosComisionFreelanceHistorico();
      return;
    }

    if (usuarioComisionFreelanceTarifa.rangoInferior === this.f.rangoInferior.value &&
      usuarioComisionFreelanceTarifa.rangoSuperior === this.f.rangoSuperior.value &&
      usuarioComisionFreelanceTarifa.porcentajeAplicado === this.f.porcentajeAplicado.value &&
      usuarioComisionFreelanceTarifa.porcentajeTarifa === this.f.porcentajeTarifa.value) {
      return;
    }

    if (usuarioComisionFreelanceTarifa.rangoInferior !== this.f.rangoInferior.value) {
      usuarioComisionFreelanceHistorico.datoAnterior = this.navService.buscarMensaje('USUARIOCOMISIONFREELANCETARIFA.LBL_RANGOINFERIOR') + ': ' + usuarioComisionFreelanceTarifa.rangoInferior;
      usuarioComisionFreelanceHistorico.datoNuevo = this.navService.buscarMensaje('USUARIOCOMISIONFREELANCETARIFA.LBL_RANGOINFERIOR') + ': ' + this.f.rangoInferior.value;
      this.lisUsuarioComisionFreelanceHistorico.push(Object.assign({}, usuarioComisionFreelanceHistorico));
    }

    if (usuarioComisionFreelanceTarifa.rangoSuperior !== this.f.rangoSuperior.value) {
      usuarioComisionFreelanceHistorico.datoAnterior = this.navService.buscarMensaje('USUARIOCOMISIONFREELANCETARIFA.LBL_RANGOSUPERIOR') + ': '  + usuarioComisionFreelanceTarifa.rangoSuperior;
      usuarioComisionFreelanceHistorico.datoNuevo = this.navService.buscarMensaje('USUARIOCOMISIONFREELANCETARIFA.LBL_RANGOSUPERIOR') + ': ' + this.f.rangoSuperior.value;
      this.lisUsuarioComisionFreelanceHistorico.push(Object.assign({}, usuarioComisionFreelanceHistorico));
    }

    if (usuarioComisionFreelanceTarifa.porcentajeAplicado !== this.f.porcentajeAplicado.value) {
      usuarioComisionFreelanceHistorico.datoAnterior = this.navService.buscarMensaje('USUARIOCOMISIONFREELANCETARIFA.LBL_PORCENTAJEAPLICADO') + ': ' + usuarioComisionFreelanceTarifa.porcentajeAplicado;
      usuarioComisionFreelanceHistorico.datoNuevo = this.navService.buscarMensaje('USUARIOCOMISIONFREELANCETARIFA.LBL_PORCENTAJEAPLICADO') + ': ' + this.f.porcentajeAplicado.value;
      this.lisUsuarioComisionFreelanceHistorico.push(Object.assign({}, usuarioComisionFreelanceHistorico));
    }

    if (usuarioComisionFreelanceTarifa.porcentajeTarifa !== this.f.porcentajeTarifa.value) {
      usuarioComisionFreelanceHistorico.datoAnterior = this.navService.buscarMensaje('USUARIOCOMISIONFREELANCETARIFA.LBL_PORCENTAJETARIFA') + ': ' + usuarioComisionFreelanceTarifa.porcentajeTarifa;
      usuarioComisionFreelanceHistorico.datoNuevo = this.navService.buscarMensaje('USUARIOCOMISIONFREELANCETARIFA.LBL_PORCENTAJETARIFA') + ': ' + this.f.porcentajeTarifa.value;
      this.lisUsuarioComisionFreelanceHistorico.push(Object.assign({}, usuarioComisionFreelanceHistorico));
    }

    this.guardarUsuariosComisionFreelanceHistorico();
  }

  async guardarUsuariosComisionFreelanceHistorico() {
    if (this.lisUsuarioComisionFreelanceHistorico.length === 0) {
      return;
    }
    await this.usuariosComisionesFreelanceHistoricosService.bulk(this.lisUsuarioComisionFreelanceHistorico).toPromise();
    this.lisUsuarioComisionFreelanceHistorico = [];
  }

  regresar( dirty: boolean ) {
    if ( dirty ) {
      this.conService.confirm( {
        message: this.navService.buscarMensaje( 'MSG_CANCELARCAMBIOS' ),
        header: this.navService.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        key: `comision-freelance-tarifa`,
        accept: () => {
          this.reiniciarForm();
        },
        reject: () => {
        }
      } );
    } else {
      this.reiniciarForm();
    }
  }

  inhabilitar( registro: UsuarioComisionFreelanceTarifa ) {
      this.conService.confirm( {
        message: this.navService.buscarMensaje( 'MSG_INHABILITAR' ),
        header: this.navService.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        key: 'comision-freelance-tarifa',
        accept: () => {
          this.cargando = true;
          registro.indicadorHabilitado = false;
          this.usuarioComisionFreelanceTarifaService.actualizar( registro ).subscribe( regActualizado => {
            const a = this.listado.findIndex( x => x.idUsuarioComisionFreelanceTarifa === registro.idUsuarioComisionFreelanceTarifa );
            if ( a >= 0 ) {
              this.listado.splice( a, 1 );
            }
            if (this.f.idUsuarioComisionFreelanceTarifa.value === registro.idUsuarioComisionFreelanceTarifa){
              this.reiniciarForm();
            }
            this.navService.setMesage(2);
            this.cargando = false;
          } );
        },
        reject: () => {
        }
      } );
  }

  get f() {
    return this.formulario.controls;
  }

  reiniciarForm( setSeleccionado: boolean = true ) {
    if ( setSeleccionado ) {
      this.regSeleccionado = null;
    }
    this.submitted = false;
    this.cargarFormulario();
    this.formulario.markAsPristine();
  }

  calcularTarifa() {
    this.f.porcentajeTarifa.setValue((this.f.porcentajeAplicado.value || this.f.porcentajeAplicado.value === 0 ) ? roundCustom((this.f.porcentajeAplicado.value * this.comisionFreelance.porcentajeComision) / 100, 2) : null);
  }

  validarRango() {
    const inferior = Number( this.f.rangoInferior.value );
    const superior = Number( this.f.rangoSuperior.value );
    if ( inferior >= superior ) {
      return this.navService.buscarMensaje('USUARIOCOMISIONFREELANCETARIFA.MSG_RANGOINCORRECTO');
    }

    if(!!this.listado.find(x => ((Number(x.rangoInferior) >= inferior && Number(x.rangoInferior) < superior) || (Number(x.rangoSuperior) > inferior && Number(x.rangoSuperior) <= superior) ) && (!this.f.idUsuarioComisionFreelanceTarifa.value || this.f.idUsuarioComisionFreelanceTarifa.value !== x.idUsuarioComisionFreelanceTarifa))){
      return this.navService.buscarMensaje('USUARIOCOMISIONFREELANCETARIFA.MSG_RANGOCONTENIDO');
    }
    return;
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

}
